<template>
  <BTooltipButton
    :disabled="disabled"
    :class-button="['b-table-button-expand', { 'is-active': active }]"
    icon="mdi-chevron-down"
    depressed
    small
    top
    v-on="$listeners || {}"
  />
</template>

<script>
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'BTableButtonExpand',
  components: {
    BTooltipButton,
  },
  props: {
    active: Boolean,
    disabled: Boolean,
  },
}
</script>

<style lang="scss">

.b-table-button-expand {
  transition: all 0.5s;

  &.is-active {
    transform: rotate(180deg);
  }
}
</style>
